/* eslint-disable camelcase */
import apron from "./apron";
import backpack from "./backpack";
import badge from "./badge";
import bag from "./bag";
import bandana from "./bandana";
import basketball_uniform from "./basketball-uniform";
import beanie from "./beanie";
import beer_mug from "./beer-mug";
import bib from "./bib";
import blackberry_z10_case from "./blackberry-z10-case";
import bodysuit from "./bodysuit";
import business_card from "./business-card";
import cake from "./cake";
import calendar_a2 from "./calendar-a2";
import calendar_a3 from "./calendar-a3";
import calendar_single_a2 from "./calendar-single-a2";
import canvas20x30 from "./canvas20x30";
import canvas30x30 from "./canvas30x30";
import canvas30x40 from "./canvas30x40";
import canvas30x60 from "./canvas30x60";
import canvas40x55 from "./canvas40x55";
import canvas50x50 from "./canvas50x50";
import canvas50x75 from "./canvas50x75";
import canvas60x90 from "./canvas60x90";
import cap_trucker from "./cap-trucker";
import chocolate from "./chocolate";
import chocolate_set_shell from "./chocolate-set-shell";
import chocolate_set_souffle from "./chocolate-set-souffle";
import chocolate_set4 from "./chocolate-set4";
import chocolate_set12 from "./chocolate-set12";
import chocolate_set16 from "./chocolate-set16";
import chocolate35x35 from "./chocolate35x35";
import classic_polo_shirt from "./classic-polo-shirt";
import classic_tee from "./classic-tee";
import classic_woman_polo from "./classic-woman-polo";
import classic_woman_tee from "./classic-woman-tee";
import colored_handle_mug from "./colored-handle-mug";
import colored_inside_mug from "./colored-inside-mug";
import cube from "./cube";
import dog_tee from "./dog-tee";
import euro_business_card from "./euro-business-card";
import flag22x15 from "./flag22x15";
import flag135x90 from "./flag135x90";
import flag150x100 from "./flag150x100";
import free_form_sticker from "./free-form-sticker";
import football_uniform from "./football-uniform";
import full_print_apron from "./full-print-apron";
import full_print_backpack from "./full-print-backpack";
import full_print_bag from "./full-print-bag";
import full_print_beanie from "./full-print-beanie";
import full_print_boy_tee from "./full-print-boy-tee";
import full_print_gloves from "./full-print-gloves";
import full_print_girl_tee from "./full-print-girl-tee";
import full_print_hoodie from "./full-print-hoodie";
import full_print_kids_sweatshirt from "./full-print-kids-sweatshirt";
import full_print_man_polo from "./full-print-man-polo";
import full_print_mug from "./full-print-mug";
import full_print_neck_pillow from "./full-print-neck-pillow";
import full_print_pencil_case from "./full-print-pencil-case";
import full_print_pencil_skirt from "./full-print-pencil-skirt";
import full_print_skirt from "./full-print-skirt";
import full_print_sport_tee from "./full-print-sport-tee";
import full_print_summer_dress from "./full-print-summer-dress";
import full_print_sweatshirt from "./full-print-sweatshirt";
import full_print_tanktop from "./full-print-tanktop";
import full_print_tee from "./full-print-tee";
import full_print_waist_bag from "./full-print-waist-bag";
import full_print_woman_hoodie from "./full-print-woman-hoodie";
import full_print_woman_polo from "./full-print-woman-polo";
import full_print_woman_sweatshirt from "./full-print-woman-sweatshirt";
import full_print_woman_tanktop from "./full-print-woman-tanktop";
import full_print_woman_tee from "./full-print-woman-tee";
import galaxy_note_case from "./galaxy-note-case";
import galaxy_note2_case from "./galaxy-note2-case";
import galaxy_s2_case from "./galaxy-s2-case";
import galaxy_s3_case from "./galaxy-s3-case";
import galaxy_s4_case from "./galaxy-s4-case";
import galaxy_s5_case from "./galaxy-s5-case";
import galaxy_s6_case from "./galaxy-s6-case";
import galaxy_s6_edge_case from "./galaxy-s6-edge-case";
import galaxy_s7_case from "./galaxy-s7-case";
import galaxy_s7_edge_case from "./galaxy-s7-edge-case";
import galaxy_s7_edge_leather_case from "./galaxy-s7-edge-leather-case";
import galaxy_s7_edge_silicone_case from "./galaxy-s7-edge-silicone-case";
import galaxy_s7_leather_case from "./galaxy-s7-leather-case";
import galaxy_s7_silicone_case from "./galaxy-s7-silicone-case";
import galaxy_s8_case from "./galaxy-s8-case";
import galaxy_s8_leather_case from "./galaxy-s8-leather-case";
import galaxy_s8_plus_case from "./galaxy-s8-plus-case";
import galaxy_s8_plus_leather_case from "./galaxy-s8-plus-leather-case";
import galaxy_s8_plus_silicone_case from "./galaxy-s8-plus-silicone-case";
import galaxy_s8_silicone_case from "./galaxy-s8-silicone-case";
import hat from "./hat";
import heart_magnet75x97 from "./heart-magnet75x97";
import heart_mouse_pad from "./heart-mouse-pad";
import heart_sticker50x65 from "./heart-sticker50x65";
import heart_sticker75x97 from "./heart-sticker75x97";
import hoodie from "./hoodie";
import iphone_x_case from "./iphone-x-case";
import iphone11_case from "./iphone11-case";
import iphone11_pro_case from "./iphone11-pro-case";
import iphone11_pro_max_case from "./iphone11-pro-max-case";
import iphone4_case from "./iphone4-case";
import iphone4_glossy_case from "./iphone4-glossy-case";
import iphone5_case from "./iphone5-case";
import iphone5_glossy_case from "./iphone5-glossy-case";
import iphone5_kickstand_case from "./iphone5-kickstand-case";
import iphone5_volumetric_case from "./iphone5-volumetric-case";
import iphone6_case from "./iphone6-case";
import iphone6_plus_case from "./iphone6-plus-case";
import iphone6_plus_glossy_case from "./iphone6-plus-glossy-case";
import iphone6_volumetric_case from "./iphone6-volumetric-case";
import iphone7_case from "./iphone7-case";
import iphone7_glossy_case from "./iphone7-glossy-case";
import iphone7_plus_case from "./iphone7-plus-case";
import iphone7_plus_glossy_case from "./iphone7-plus-glossy-case";
import iphone8_case from "./iphone8-case";
import iphone8_plus_case from "./iphone8-plus-case";
import kids_football_uniform from "./kids-football-uniform";
import kids_tee from "./kids-tee";
import laptop_sleeve12 from "./laptop-sleeve12";
import laptop_sleeve14 from "./laptop-sleeve14";
import large_envelope from "./large-envelope";
import large_pencil_case from "./large-pencil-case";
import leggings from "./leggings";
import long_sleeve_dress from "./long-sleeve-dress";
import longsleeve from "./longsleeve";
import man_bomber from "./man-bomber";
import man_pajama_pants from "./man-pajama-pants";
import man_pants from "./man-pants";
import man_stretch_tee from "./man-stretch-tee";
import man_underpants from "./man-underpants";
import mask from "./mask";
import maternity_tee from "./maternity-tee";
import medium_envelope from "./medium-envelope";
import metal_bottle from "./metal-bottle";
import mouse_pad from "./mouse-pad";
import mug from "./mug";
import notebook_glued from "./notebook-glued";
import notebook_spring from "./notebook-spring";
import notebook_stapled from "./notebook-stapled";
import notepad_a4 from "./notepad-a4";
import notepad from "./notepad";
import oval_sticker150x90 from "./oval-sticker150x90";
import oval_sticker98x70 from "./oval-sticker98x70";
import package155x220x50 from "./package155x220x50";
import package220x155x50 from "./package220x155x50";
import package250x350x80 from "./package250x350x80";
import paired_tee from "./paired-tee";
import passport_cover from "./passport-cover";
import pillow from "./pillow";
import pillow40x40 from "./pillow40x40";
import pillow60x40 from "./pillow60x40";
import plaid_fleece130x170 from "./plaid-fleece130x170";
import pleated_skirt from "./pleated-skirt";
import polo_shirt from "./polo-shirt";
import postcard from "./postcard";
import postcard15x10 from "./postcard15x10";
import postcard21x10 from "./postcard21x10";
import poster_a2 from "./poster-a2";
import poster from "./poster";
import puzzle_a3 from "./puzzle-a3";
import puzzle_a4 from "./puzzle-a4";
import puzzle408 from "./puzzle408";
import puzzle1000 from "./puzzle1000";
import rashguard from "./rashguard";
import rectangle_keychain35x25 from "./rectangle-keychain35x25";
import rectangle_keychain50x35 from "./rectangle-keychain50x35";
import rectangle_magnet90x50 from "./rectangle-magnet90x50";
import rectangle_magnet150x45 from "./rectangle-magnet150x45";
import rectangle_sticker90x50 from "./rectangle-sticker90x50";
import rectangle_sticker150x45 from "./rectangle-sticker150x45";
import ringer_man_tee from "./ringer-man-tee";
import ringer_woman_tee from "./ringer-woman-tee";
import round_magnet50x50 from "./round-magnet50x50";
import round_mouse_pad from "./round-mouse-pad";
import round_plastic_clock from "./round-plastic-clock";
import round_sticker50x50 from "./round-sticker50x50";
import round_sticker95x95 from "./round-sticker95x95";
import round_wood_clock from "./round-wood-clock";
import shower_curtain from "./shower-curtain";
import sleep_mask from "./sleep-mask";
import sleeveless_dress from "./sleeveless-dress";
import small_envelope from "./small-envelope";
import small_pencil_case from "./small-pencil-case";
import snapback from "./snapback";
import square_keychain from "./square-keychain";
import square_magnet50x50 from "./square-magnet50x50";
import square_magnet95x95 from "./square-magnet95x95";
import square_pillow from "./square-pillow";
import square_sticker50x50 from "./square-sticker50x50";
import square_sticker95x95 from "./square-sticker95x95";
import square_tablecloth from "./square-tablecloth";
import square_wood_clock from "./square-wood-clock";
import star_magnet75x75 from "./star-magnet75x75";
import star_sticker75x75 from "./star-sticker75x75";
import star_sticker145x145 from "./star-sticker145x145";
import stone_photo_frame from "./stone-photo-frame";
import stretch_tee from "./stretch-tee";
import sweatshirt from "./sweatshirt";
import tanktop from "./tanktop";
import tapestry180x145 from "./tapestry180x145";
import tee from "./tee";
import towel30x30 from "./towel30x30";
import towel35x75 from "./towel35x75";
import towel50x90 from "./towel50x90";
import umbrella_bilateral from "./umbrella-bilateral";
import umbrella_unilateral from "./umbrella-unilateral";
import woman_bomber from "./woman-bomber";
import woman_pajama_pants from "./woman-pajama-pants";
import woman_pants from "./woman-pants";
import woman_polo from "./woman-polo";
import woman_tanktop from "./woman-tanktop";
import woman_tee from "./woman-tee";
import woman_underpants from "./woman-underpants";

export default {
  apron,
  backpack,
  badge,
  bag,
  bandana,
  basketball_uniform,
  beanie,
  beer_mug,
  bib,
  blackberry_z10_case,
  bodysuit,
  business_card,
  cake,
  calendar_a2,
  calendar_a3,
  calendar_single_a2,
  canvas20x30,
  canvas30x30,
  canvas30x40,
  canvas30x60,
  canvas40x55,
  canvas50x50,
  canvas50x75,
  canvas60x90,
  cap_trucker,
  chocolate,
  chocolate_set_shell,
  chocolate_set_souffle,
  chocolate_set4,
  chocolate_set12,
  chocolate_set16,
  chocolate35x35,
  classic_polo_shirt,
  classic_tee,
  classic_woman_polo,
  classic_woman_tee,
  colored_handle_mug,
  colored_inside_mug,
  cube,
  dog_tee,
  euro_business_card,
  flag22x15,
  flag135x90,
  flag150x100,
  free_form_sticker,
  football_uniform,
  full_print_apron,
  full_print_backpack,
  full_print_bag,
  full_print_beanie,
  full_print_boy_tee,
  full_print_gloves,
  full_print_girl_tee,
  full_print_hoodie,
  full_print_kids_sweatshirt,
  full_print_man_polo,
  full_print_mug,
  full_print_neck_pillow,
  full_print_pencil_case,
  full_print_pencil_skirt,
  full_print_skirt,
  full_print_sport_tee,
  full_print_summer_dress,
  full_print_sweatshirt,
  full_print_tanktop,
  full_print_tee,
  full_print_waist_bag,
  full_print_woman_hoodie,
  full_print_woman_polo,
  full_print_woman_sweatshirt,
  full_print_woman_tanktop,
  full_print_woman_tee,
  galaxy_note_case,
  galaxy_note2_case,
  galaxy_s2_case,
  galaxy_s3_case,
  galaxy_s4_case,
  galaxy_s5_case,
  galaxy_s6_case,
  galaxy_s6_edge_case,
  galaxy_s7_case,
  galaxy_s7_edge_case,
  galaxy_s7_edge_leather_case,
  galaxy_s7_edge_silicone_case,
  galaxy_s7_leather_case,
  galaxy_s7_silicone_case,
  galaxy_s8_case,
  galaxy_s8_leather_case,
  galaxy_s8_plus_case,
  galaxy_s8_plus_leather_case,
  galaxy_s8_plus_silicone_case,
  galaxy_s8_silicone_case,
  hat,
  heart_magnet75x97,
  heart_mouse_pad,
  heart_sticker50x65,
  heart_sticker75x97,
  hoodie,
  iphone_x_case,
  iphone11_case,
  iphone11_pro_case,
  iphone11_pro_max_case,
  iphone4_case,
  iphone4_glossy_case,
  iphone5_case,
  iphone5_glossy_case,
  iphone5_kickstand_case,
  iphone5_volumetric_case,
  iphone6_case,
  iphone6_plus_case,
  iphone6_plus_glossy_case,
  iphone6_volumetric_case,
  iphone7_case,
  iphone7_glossy_case,
  iphone7_plus_case,
  iphone7_plus_glossy_case,
  iphone8_case,
  iphone8_plus_case,
  kids_football_uniform,
  kids_tee,
  laptop_sleeve12,
  laptop_sleeve14,
  large_envelope,
  large_pencil_case,
  leggings,
  long_sleeve_dress,
  longsleeve,
  man_bomber,
  man_pants,
  man_pajama_pants,
  man_stretch_tee,
  man_underpants,
  mask,
  maternity_tee,
  medium_envelope,
  metal_bottle,
  mouse_pad,
  mug,
  notebook_glued,
  notebook_spring,
  notebook_stapled,
  notepad_a4,
  notepad,
  oval_sticker150x90,
  oval_sticker98x70,
  package155x220x50,
  package220x155x50,
  package250x350x80,
  paired_tee,
  passport_cover,
  pillow,
  pillow40x40,
  pillow60x40,
  plaid_fleece130x170,
  pleated_skirt,
  polo_shirt,
  postcard,
  postcard15x10,
  postcard21x10,
  poster_a2,
  poster,
  puzzle_a3,
  puzzle_a4,
  puzzle408,
  puzzle1000,
  rashguard,
  rectangle_keychain35x25,
  rectangle_keychain50x35,
  rectangle_magnet90x50,
  rectangle_magnet150x45,
  rectangle_sticker90x50,
  rectangle_sticker150x45,
  ringer_man_tee,
  ringer_woman_tee,
  round_magnet50x50,
  round_mouse_pad,
  round_plastic_clock,
  round_sticker50x50,
  round_sticker95x95,
  round_wood_clock,
  shower_curtain,
  sleep_mask,
  sleeveless_dress,
  small_envelope,
  small_pencil_case,
  snapback,
  square_keychain,
  square_magnet50x50,
  square_magnet95x95,
  square_pillow,
  square_sticker50x50,
  square_sticker95x95,
  square_tablecloth,
  square_wood_clock,
  star_magnet75x75,
  star_sticker75x75,
  star_sticker145x145,
  stone_photo_frame,
  stretch_tee,
  sweatshirt,
  tanktop,
  tapestry180x145,
  tee,
  towel30x30,
  towel35x75,
  towel50x90,
  umbrella_bilateral,
  umbrella_unilateral,
  woman_bomber,
  woman_pajama_pants,
  woman_pants,
  woman_polo,
  woman_tanktop,
  woman_tee,
  woman_underpants
};
